import { isEmail, isMobilePhone, isNumeric } from 'validator'
import { translate } from './filters'
export interface RuleType {
    field: 'user'
    fullField: 'user'
    type: 'string'
    validator: () => any
}

export default class FormValidator {
    mail(message?: string) {
        return (rule: RuleType, value: any, callback: (error?: Error) => void) => {
            if (value && !isEmail(value)) {
                callback(new Error(message || translate('common.validator.email')))
                return
            }
            callback()
        }
    }
    mobile(message?: string) {
        return (rule: RuleType, value: any, callback: (error?: Error) => void) => {
            const local = 'zh-CN' // default TODO get from local
            if (value && !isMobilePhone(value, local)) {
                callback(new Error(message || translate('common.validator.mobile')))
                return
            }
            callback()
        }
    }
    number(message?: string) {
        return (rule: any, value_: any, callback: (error?: Error) => void) => {
            const value = value_.toString()
            if (value && !isNumeric(String(value))) {
                callback(new Error(message || translate('common.validator.number')))
                return
            }
            callback()
        }
    }
    password(max = 20) {
        return (rule: any, value_: any, callback: (error?: Error) => void) => {
            const value = value_.toString()
            // eslint-disable-next-line
            if (value && !new RegExp(`^[0-9a-zA-Z_]{1,20}$`, 'g').test(value)) {
                callback(new Error(translate('common.validator.password', { length: max })))
                return
            }
            callback()
        }
    }
    maxLength(max = 20) {
        return (rule: any, value_: any, callback: (error?: Error) => void) => {
            const value = value_.toString()
            if (value && value.length > max) {
                callback(new Error(translate('common.validator.maxLength', { length: max })))
                return
            }
            callback()
        }
    }
}
